import { formatDateTimeReadable, SinglePaymentCriteria } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const updatedAtWithBorrowerNameFieldColumnMobile = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();
  return {
    flex: flex ?? 0.6,
    field: 'updated_at',
    headerName: <Text tId={'UPDATE_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: { row: SinglePaymentCriteria }) => {
      return (
        <div className={'overflow-text-ellipsis'}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Font color="textPrimary" variant="caption" style={{ lineHeight: '1.43rem' }}>
              <strong>{formatDateTimeReadable(rowData.row.updatedAt)}</strong>
            </Font>
          </div>
          <span style={{ color: palette.text.secondary }}>
            {`${rowData.row.customer.fullName.firstName} ${rowData.row.customer.fullName.lastName}`}
          </span>
          <div className={'overflow-text-ellipsis'}>
            <Font color="textSecondary" variant={'caption'}>
              {rowData.row.businessName}
            </Font>
          </div>
        </div>
      );
    },
  };
};
